import { Box, Divider, Paper } from "@mui/material";
import { colors } from "@components/ui/colors";
import { SkeletonBlock } from "@components/Skeleton";

export const PriceBreakdownSkeleton = () => {
    return (
        <Paper
            elevation={0}
            sx={{
                border: `1.5px solid ${colors.gray[100]}`,
                borderRadius: "16px",
                p: 2.25,
                boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1.75,
                }}
            >
                <SkeletonBlock width={120} height={18} radius="6px" />
                <SkeletonBlock variant="circle" width={24} height={24} />
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
                {Array.from({ length: 3 }).map((_, index) => (
                    <Box key={index}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                py: 1,
                                gap: 2,
                            }}
                        >
                            <SkeletonBlock width="42%" height={14} radius="6px" />
                            <SkeletonBlock width={72} height={16} radius="6px" />
                        </Box>

                        {index < 2 && <Divider sx={{ borderColor: colors.gray[50] }} />}
                    </Box>
                ))}
            </Box>

            <SkeletonBlock width={110} height={16} radius="6px" sx={{ mt: 1.5 }} />
        </Paper>
    );
};